import './../../stylesheets/rule_activity_fields';

// チェックボックスの選択サポート
export function fieldCustom () {
  let targets = document.querySelectorAll('.rule-activity-field-item');
  for (let i = 0; i < targets.length; i++) {
    if (!!targets[i]) {
      targets[i].addEventListener('click', function(event) {
        if (event.target == this) {
          this.querySelector('input[type="checkbox"]').click();
        }
      });
    }
  }
}